import { render, staticRenderFns } from "./SbolFooter.vue?vue&type=template&id=a6fa6040&scoped=true&"
var script = {}
function injectStyles (context) {
  
  var style0 = require("./SbolFooter.vue?vue&type=style&index=0&id=a6fa6040&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a6fa6040",
  null
  ,true
)

export default component.exports